import axios from "axios";
import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateVoteDetail, updateVoteNowPopup } from "./votenow.slice";
import { updateMyRound } from "../Pages/RoundToJoin/roundToJoin.slice";
import { updateMypot } from "../Pages/Dashboard/dashboard.slice";
import { baseURL } from "../services/axiosConfig";
import { refreshTokenV2 } from "../services/api";

function VotePopup({ potId, pickId, message, logo, jackpotId }) {
  const dispatch = useDispatch();
  const myRoundPot = useSelector((state) => state.roundToJoin.myRound);
  const myRoundsDash = useSelector((state) => state.dashboard.potInfo);

  async function updateHandler(vote) {
    try {
      const rawToken = localStorage.getItem("access_token");
      const token = rawToken ? JSON.parse(rawToken) : null;
      const url = `${baseURL}/pot/jackpotupdate/${potId}`;
      const res = await axios.put(
        url,
        { pick_id: pickId, vote: vote.toLowerCase() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.status === 200) {
        const path = window.location.pathname;
        if (path === "/dashboard") {
          const updateMyPot = myRoundsDash.myRounds[0].pots.map((ele) => {
            if (ele.id == potId) {
              const updatedPickId = ele.pick_id.map((item) => {
                if (item.pick_id === pickId) {
                  return {
                    ...item,
                    prediction: {
                      ...item.prediction,
                      vote: res.data.is_vote,
                    },
                  };
                }
                return item;
              });

              return {
                ...ele,
                pick_id: updatedPickId,
              };
            }
            return ele;
          });
          dispatch(
            updateMypot([
              {
                user: myRoundsDash.user,
                pots: updateMyPot,
              },
            ])
          );
        } else {
          const updatedPot = myRoundPot.map((ele) => {
            if (ele.id === potId) {
              const updatedPickId = ele.pick_id.map((item) => {
                if (item.pick_id === pickId) {
                  return {
                    ...item,
                    prediction: {
                      ...item.prediction,
                      vote: res.data.is_vote,
                    },
                  };
                }
                return item;
              });
              return {
                ...ele,
                pick_id: updatedPickId,
              };
            }
            return ele;
          });

          dispatch(updateMyRound(updatedPot));
        }

        dispatch(
          updateVoteDetail({
            pot: potId,
            pick: pickId,
            vote: res.data.is_vote,
            logo: logo,
          })
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      console.error(error);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 bg-black/10 flex items-center justify-center p-4"
      onClick={() => dispatch(updateVoteNowPopup(false))}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-sm text-center space-y-6"
      >
        {/* Close Icon */}
        <button
          onClick={() => dispatch(updateVoteNowPopup(false))}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
        >
          &times;
        </button>

        <p className="text-lg font-semibold text-gray-800">{message}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => {
              updateHandler("No");
              dispatch(updateVoteNowPopup(false));
            }}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg"
          >
            No
          </button>
          <button
            onClick={() => {
              updateHandler("Yes");
              dispatch(updateVoteNowPopup(false));
            }}
            className="px-4 py-2 bg-green-600 text-white rounded-lg"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}

export default VotePopup;
